__turbopack_context__.v({
  "fogContainer": "fog-background-module__CVZLEG__fogContainer",
  "fogLayer": "fog-background-module__CVZLEG__fogLayer",
  "fog_effect": "fog-background-module__CVZLEG__fog_effect",
  "fog_effect_reduced": "fog-background-module__CVZLEG__fog_effect_reduced",
});
